/**
 * pin-products.js
 *
 * Collection page URL param: ?pin=handle-1,handle-2
 * Pins the given product handles to the top of the #product-grid list,
 * in the exact order given in the URL. All other products keep following
 * in their normal order after the pinned ones.
 *
 * Example:
 *   /collections/all?pin=school-water-bottle,3-5l-5-0l-triply-outer-lid-pressure-pan-handle-set-copy
 *
 * Notes:
 * - Multiple "pin" params also work: ?pin=handle-1&pin=handle-2
 * - This only reorders products that already exist in the current grid /
 *   current page. It does not fetch a pinned product from another page.
 * - Existing <li> nodes are moved (not re-created), so all bound behaviour
 *   -- add to cart, quick add, variant selectors, etc. -- keeps working.
 */
(function () {
  function getPinnedHandles() {
    var params = new URLSearchParams(window.location.search);
    var raw = [];

    params.getAll('pin').forEach(function (value) {
      value.split(',').forEach(function (handle) {
        handle = handle.trim();
        if (handle) raw.push(handle);
      });
    });

    var seen = {};
    var handles = [];
    raw.forEach(function (handle) {
      if (!seen[handle]) {
        seen[handle] = true;
        handles.push(handle);
      }
    });

    return handles;
  }

  function reorderProductGrid() {
    var pinnedHandles = getPinnedHandles();
    if (!pinnedHandles.length) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var items = Array.prototype.filter.call(grid.children, function (el) {
      return el.hasAttribute && el.hasAttribute('data-product-handle');
    });
    if (!items.length) return;

    var byHandle = {};
    items.forEach(function (item) {
      byHandle[item.getAttribute('data-product-handle')] = item;
    });

    var pinnedItems = [];
    var pinnedSet = {};
    pinnedHandles.forEach(function (handle) {
      var item = byHandle[handle];
      if (item && !pinnedSet[handle]) {
        pinnedItems.push(item);
        pinnedSet[handle] = true;
      }
    });
    if (!pinnedItems.length) return;

    var restItems = items.filter(function (item) {
      return !pinnedSet[item.getAttribute('data-product-handle')];
    });

    var desiredOrder = pinnedItems.concat(restItems);

    var alreadyInOrder = desiredOrder.every(function (item, index) {
      return items[index] === item;
    });
    if (alreadyInOrder) return;

    desiredOrder.forEach(function (item) {
      grid.appendChild(item);
    });
  }

  function init() {
    reorderProductGrid();

    var container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        reorderProductGrid();
      });
      observer.observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
